package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.*
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import com.iptvplayer.shared.util.Constants

class AuthApi(private val client: HttpClient) {
    suspend fun register(request: RegisterRequestDto): AuthResponseDto =
        client.post("${Constants.BASE_URL}/api/auth/register") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun login(request: LoginRequestDto): AuthResponseDto =
        client.post("${Constants.BASE_URL}/api/auth/login") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun refreshToken(request: RefreshRequestDto): TokenResponseDto =
        client.post("${Constants.BASE_URL}/api/auth/refresh") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun logout() {
        client.post("${Constants.BASE_URL}/api/auth/logout")
    }

    /** Flags the account for deletion; an admin reviews before the purge. */
    suspend fun requestAccountDeletion() {
        client.delete("${Constants.BASE_URL}/api/auth/account")
    }
}
